// Llamadas al API de Gestión de permisos obras (solo administradores de Grupo Atlante).
// Contrato: book-bsk-api/BookBSK/Controllers/ObrasPermisosController.cs.
import { getApiInstance, initializeApi } from "../../../utils/api";

const api = async () => {
    await initializeApi();
    return getApiInstance();
};

export async function fetchConfiguraciones() {
    const response = await (await api()).get("/api/obras/permisos/configuraciones");
    return Array.isArray(response?.data) ? response.data : [];
}

export async function fetchGrupos() {
    const response = await (await api()).get("/api/obras/permisos/grupos");
    return Array.isArray(response?.data) ? response.data : [];
}

export async function fetchDimensiones() {
    const response = await (await api()).get("/api/obras/permisos/dimensiones");
    return Array.isArray(response?.data) ? response.data : [];
}

// Alta (codConfiguracion 0) o edición. Devuelve el código.
export async function guardarConfiguracion(codConfiguracion, cuerpo) {
    const cliente = await api();
    const response = codConfiguracion
        ? await cliente.put(`/api/obras/permisos/configuraciones/${codConfiguracion}`, cuerpo)
        : await cliente.post("/api/obras/permisos/configuraciones", cuerpo);
    return Number(response?.data?.codConfiguracion) || codConfiguracion;
}

export async function borrarConfiguracion(codConfiguracion) {
    await (await api()).delete(`/api/obras/permisos/configuraciones/${codConfiguracion}`);
}

// null quita el acceso al grupo.
export async function asignarGrupo(codEmpresa, codPerfil, codConfiguracion) {
    await (await api()).put(`/api/obras/permisos/grupos/${codEmpresa}/${codPerfil}`, { codConfiguracion });
}

// Mensaje del API o uno genérico.
export const mensajeError = (error, porDefecto) => error?.response?.data?.message || porDefecto;
